<app-header-tela titulo="Pagamento"></app-header-tela>

<form id="form" [ngClass]="{'needs-validation': !frm.submitted, 'was-validated': frm.submitted}"
      novalidate #frm="ngForm" (ngSubmit)="onSubmit()" *ngIf="pedido">
  <div  >
    <div class="mt-3"></div>

    <div class="alert alert-danger mt-2" role="alert" *ngIf="msgErro">
      <i class="mdi mdi-block-helper mr-2"></i> {{msgErro}}
    </div>

    <ng-container *ngIf="pedido.taxaFormaDePagamento > 0">
      <div class=" pt-0  ">
        <div class="media mt-2">
          <div class="media-body">
            <h5 class="mt-0 mb-1"><span>Sub-total</span></h5>
          </div>
          <h4 class="mt-0  ">{{(pedido.total - pedido.taxaFormaDePagamento ) | currency: 'BRL'}}</h4>
        </div>
      </div>

      <div class=" pt-0 ">
        <div class="media borda-pontilhada">
          <div class="media-body">
            <h5 class="mt-0 mb-1"><span>Taxa forma de pagamento</span></h5>
          </div>
          <h4 class="mt-0  ">{{pedido.taxaFormaDePagamento | currency: 'BRL'}}</h4>
        </div>
      </div>

    </ng-container>

    <div class="produto pt-0 pb-2">
      <div class="media mt-2">
        <div class="media-body">
          <h4 class="mt-0 mb-1"><span>Total</span></h4>
        </div>
        <h4 class="mt-0 preco">{{pedido.total | currency: 'BRL'}}</h4>
      </div>
    </div>

    <ng-container *ngIf="cashback && cashback.podeUsarNaLoja">
      <h5>Usar meu <b>saldo de Cashback</b> para pagar </h5>

      <div class="k-display-inline-flex">

        <div class="flex-row">
          <a  (click)="irParaAtualizarCadastro()" *ngIf="cashback.atualizarCadastro" href="">
            <b>Atualizar meu cadastro </b>
            <br>
            <small class="text-muted">Atualize seu cadastro para utilizar seu cashback</small>
          </a>

          <a  (click)="irParaLogin()" *ngIf="cashback.fazerLogin" href="">
            <b>Identifique-se</b>
            <br>
            <small class="text-muted">Faça login para utilizar seu cashback</small>
          </a>

          <a  (click)="irparaOptin()" *ngIf="cashback.fazerOptin ||  cashback.fazerOptinUsarSaldo" href="">
            <b>Quero ganhar cashback</b>
            <br>
            <small class="text-muted">Participe do plano fidelidade para ganhar até 20% de cashback</small>
          </a>


          <div class="form-group mb-2 mt-2" [hidden]="cashback.atualizarCadastro || cashback.fazerLogin || cashback.fazerOptin || cashback.fazerOptinUsarSaldo">
            <input id="usarSaldo" name="usarSaldo" type="checkbox"    kendoCheckBox (click)="marcouUsarCashback()"
                   [(ngModel)]="cashback.usar"      class="k-checkbox" [disabled]="cashbackDesabilitado()"/>
            <label for="usarSaldo" class="ml-1"  >
              Cashback disponível <span class="preco"><b>{{ obtenhaSaldo()}}</b></span>
            </label>

            <p class="mt-1" *ngIf="!cashback.podeUsar && cashback.minimo" >
              <i class="fa fa-exclamation-circle mr-1 text-warning "></i>
              Acumule <span class=" text-blue"><b>{{ cashback.minimo | currency:"BRL"}}</b></span> de cashback
              e utilize como forma de pagamento.</p>

            <p class="mt-1" *ngIf="cashback.podeUsar && !cashback.podeUsarNoPedido" >
              <i class="fa fa-exclamation-circle mr-1 text-warning "></i>
              Faça um pedido a partir de <span class=" text-blue"><b>{{ cashback.minimoPedido | currency:"BRL"}}</b></span>
              e utilize seu saldo como forma de pagamento.</p>

          </div>
        </div>

        <div class="flex-row">
          <img src="{{empresa.integracaoFidelidade?.logo}}" class="ml-2 logo-plano" [ngClass]="{'gendai': empresa.idRede === 2}"
               *ngIf="empresa.integracaoFidelidade?.logo">
        </div>
      </div>

      <span [hidden]="obtenhaTotalPagar() === 0">
          <hr class="linha">

          <div class="produto pt-0 pb-2">
            <div class="media mt-2">
              <div class="media-body">
                <h5 class="mt-0 mb-1"><span>Total restante a pagar</span></h5>
              </div>
              <h4 class="mt-0 preco">{{obtenhaTotalPagar() | currency: 'BRL'}}</h4>
            </div>
          </div>
      </span>


    </ng-container>

    <ng-container *ngIf="obtenhaTotalPagar() > 0">
      <h4 class="mb-3">Forma de pagamento</h4>

      <ng-container *ngIf="formasDePagamentoPix.length > 0 && estaHabilitado(formasDePagamentoPix[0], pedido)">
        <h5>Pagar Agora Via Pix</h5>
        <div class="form-group mb-3 mt-2 escolher">
          <div class="mr-3 radio radio-blue mb-1"
               *ngFor="let formaDePagamento of formasDePagamentoPix">
            <img src="https://user-images.githubusercontent.com/33992396/99478353-00e4d600-2933-11eb-8228-4bafe8571507.png" style="width: 32px;" class="mr-1"/>
            <input [id]="'formaPagamento' + formaDePagamento.id" name="formaDePagamento" type="radio"    kendoRadioButton
                   [(ngModel)]="pagamento.formaDePagamento" [value]="formaDePagamento" class="k-radio"
                   (ngModelChange)="alterouFormaDePagamentoParaPix()"
                   [required]="true"/>
            <label for="formaPagamento{{formaDePagamento.id}}" class="ml-1 d-inline">
              {{formaDePagamento.descricao}}

              <span class="text-muted float-right" *ngIf="formaDePagamento.taxaCobranca && formaDePagamento.taxaCobranca.ativa">
               <i>+{{formaDePagamento.taxaCobranca.percentual}}% taxa</i></span>
            </label>
          </div>

          <div class="invalid-feedback" *ngIf="!pagamento.formaDePagamento">
            <p>Escolha a forma de pagamengo do seu pedido</p>
          </div>
        </div>

        <div class="form-group" *ngIf="pagamento.formaDePagamento && pagamento.formaDePagamento.pix">
          <h5 for="trocoParaM">Informe seu Email</h5>
          <input id="emailPix" name="emailPix" type="text" class="form-control" #txtEmailPix
                 #emailPix="ngModel" placeholder="Informe seu email" [required]="true"  email="true" type="email"
                 [(ngModel)]="pedido.pagamento.dadosPix.email" appSelecionarNoFoco/>
          <div class="invalid-feedback">
            <p *ngIf="emailPix.errors?.required">
              Para pagamentos pix você deve informar seu email. Caso aconteça algum problema, usaremos esse email para te contactar.
            </p>

            <p *ngIf="emailPix.errors?.email">Informe um email válido.</p>

          </div>
        </div>
      </ng-container>
      <h5 *ngIf="formasDePagamentoOnline.length > 0" class="mt-2">Pagar agora Online</h5>

      <div class="mt-2">
        <div class="form-group mb-2 mt-2 escolher">
          <ng-container *ngFor="let formaDePagamento of formasDePagamentoOnline;">
            <div class="mr-3  mb-1 radio radio-blue" [hidden]="!estaHabilitado(formaDePagamento, pedido)"   >
              <input id="formaPagamento{{formaDePagamento.id}}" name="formaDePagamento" type="radio"    kendoRadioButton
                     [(ngModel)]="pagamento.formaDePagamento" [value]="formaDePagamento" class="k-radio"
                     (ngModelChange)="escolheuFormaDePagamentoOnline(formaDePagamento)"
                     [required]="true" #rdFormaDePagamento="ngModel"
                     [pagseguro]="{pedido: pedido, exigeCartao: exigeCartao, dadosCartao: dadosCartao,
                               exigeEndereco: formaDePagamento.configMeioDePagamento.meioDePagamento === 'pagseguro'}"/>
              <label for="formaPagamento{{formaDePagamento.id}}" class="ml-1" style="display: inline">{{formaDePagamento.descricao}}

                <span class="text-muted float-right" *ngIf="formaDePagamento.taxaCobranca && formaDePagamento.taxaCobranca.ativa">
               <i>+{{formaDePagamento.taxaCobranca.percentual}}% taxa</i></span>
              </label>

              <ng-container *ngIf="rdFormaDePagamento.errors">
                <div class="invalid-feedback" *ngIf="rdFormaDePagamento?.errors?.endereco_obrigatorio">
                  <p>Para retirada, você deve preencher o endereço do dono do cartão de crédito</p>
                </div>
              </ng-container>
              <div class="invalid-feedback" *ngIf="rdFormaDePagamento?.errors?.dados_cartao_obrigatorio">
                <p>Você deve informar os dados do cartão de crédito para fazer o pedido.</p>
              </div>
            </div>

          </ng-container>

          <div class="invalid-feedback" *ngIf="!pagamento.formaDePagamento">
            <p>Escolha a forma de pagamengo do seu pedido</p>
          </div>
        </div>
      </div>
      <div *ngIf="pedido.pagamento && exigeCartao">
        <ng-container *ngIf="pedido.pagamento.dadosCartao">
          <i class="fas fa-credit-card font-16"></i>
          <span>&nbsp; ************{{pedido.pagamento.dadosCartao.ultimosNumeros}} </span>
          <button type="button" class="btn btn-primary btn-sm" (click)="trocarCartao()">Trocar Cartão</button>
        </ng-container>
        <ng-container *ngIf="!pedido.pagamento.dadosCartao && pedido.entrega.formaDeEntrega">
          <button class="btn btn-blue btn-sm" type="button" (click)="trocarCartao()"><i class="far fa-credit-card"></i> Adicionar Cartão</button>
        </ng-container>
        <ng-container *ngIf="!pedido.pagamento.dadosCartao && !pedido.entrega.formaDeEntrega">
          <div class="alert alert-warning">
            <span>Selecione a Forma de Entrega Antes de Adicionar os dados de cartão</span>
          </div>
        </ng-container>
        <ng-container *ngIf="exigeCartao && pedido.entrega.formaDeEntrega">
          <div class="invalid-feedback" *ngIf="pedido.pagamento.dadosCartao && pedido.entrega.ehRetirada()">
            <p>Para retirada, você deve preencher o endereço do dono do cartão de crédito</p>
          </div>
        </ng-container>
      </div>


      <h5 [hidden]="!formasDePagamento?.length">Pagar na Entrega</h5>
      <div class="form-group mb-2 mt-2 escolher">
        <ng-container *ngFor="let formaDePagamento of formasDePagamento">
          <div [hidden]="!estaHabilitado(formaDePagamento, pedido)" class="mr-3 radio radio-blue mb-1"
          >
            <input [id]="'formaPagamento' + formaDePagamento.id" name="formaDePagamento" type="radio"    kendoRadioButton
                   [(ngModel)]="pagamento.formaDePagamento" [value]="formaDePagamento" class="k-radio"
                   (ngModelChange)="alterouFormaDePagamento()"
                   [required]="true"/>
            <label for="formaPagamento{{formaDePagamento.id}}" class="ml-1 d-inline">{{formaDePagamento.descricao}}

              <span class="text-muted float-right" *ngIf="formaDePagamento.taxaCobranca && formaDePagamento.taxaCobranca.ativa">
             <i>+{{formaDePagamento.taxaCobranca.percentual}}% taxa</i></span>

              <span class="text-muted float-right" *ngIf="formaDePagamento.possuiDesconto && formaDePagamento.desconto > 0">
             <i>-{{formaDePagamento.desconto}}% de desconto</i></span>
            </label>
          </div>
        </ng-container>


        <div class="invalid-feedback" *ngIf="!pagamento.formaDePagamento">
          <p>Escolha a forma de pagamengo do seu pedido</p>
        </div>
      </div>

      <div *ngIf="pedido.pagamento?.formaDePagamento?.nome === 'dinheiro'" class="mt-2" >
        <h5 class="d-inline">Vai precisar de troco?  </h5>

        <div class="form-group mb-2  ml-3 mt-2 radio radio-blue">

          <input id="trocoSim" name="temTroco" type="radio"    kendoRadioButton  class="k-radio"
                 [(ngModel)]="pedido.pagamento.temTroco" value="sim"
                 [required]="pedido.pagamento?.formaDePagamento.nome === 'dinheiro'"/>
          <label for="trocoSim" class="mr-4">&nbsp;Sim</label>

          <input id="trocoNao" name="temTroco" type="radio"    kendoRadioButton  class="k-radio"
                 [(ngModel)]="pedido.pagamento.temTroco" value="nao" (ngModelChange)="precisaDeTroco(false)"
                 [required]="pedido.pagamento?.formaDePagamento.nome === 'dinheiro'"/>
          <label for="trocoNao" class="ml-1">&nbsp;Não</label>


          <div class="invalid-feedback" *ngIf="!pedido.pagamento.temTroco">
            Informe se vai precisar de troco.
          </div>
        </div>
      </div>

      <div id="divTroco"  *ngIf="pedido.pagamento?.formaDePagamento?.nome === 'dinheiro' && pedido.pagamento.temTroco ==='sim'">
        <div class="form-group ">
          <h5 for="trocoParaM">Troco para quanto? </h5>
          <input id="trocoParaM" name="trocoParaM" type="text" inputmode="decimal" class="form-control troco"
                 #txtTrocoM="ngModel"  trocoMinimo="{{obtenhaTotalPagar()}}"
                 (ngModelChange)="calculeTroco($event)"
                 [(ngModel)]="pedido.pagamento.trocoPara" appSelecionarNoFoco
                 currencyMask [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', align: 'left' }"/>
          <div class="invalid-feedback">
            <p *ngIf="txtTrocoM.errors?.trocoMinimo">
              A nota tem que ser maior que  {{obtenhaTotalPagar() | currency: "R$"}}</p>
          </div>
        </div>
      </div>

      <div class="produto pt-0 pb-2" *ngIf="pedido.troco && pagamento.formaDePagamento.nome === 'dinheiro'">

        <div class="media mt-0" >
          <div class="media-body">
            <h5 class="mt-0 mb-1"><span>dinheiro</span></h5>
          </div>
          <h5 class="mt-0">{{pagamento.trocoPara | currency: 'BRL'}}</h5>
        </div>
        <div class="media mt-1" *ngIf="pagamento.trocoPara > 0">
          <div class="media-body">
            <h4 class="mt-0 mb-1"><span>Troco</span></h4>
          </div>
          <h4 class="mt-0 preco" [class.negativo]="pedido.troco < 0">{{pedido.troco | currency: 'BRL'}}</h4>
        </div>

        <hr class="linha">
      </div>
    </ng-container>

    <div style="height: 40px"></div>

    <footer class="footer">
      <div>
        <div class="row" style="padding: 15px;">
          <div class="col">
            <button class="btn btn-primary btn-block">Salvar Forma de Pagamento</button>
          </div>
        </div>
      </div>
    </footer>
  </div>
</form>
